import { GroupOfSelectable } from "@tenforce/product-fields"
import { Type } from "../../../../apis/models/selectors/models"

export function isFieldTypeSingleSelect(type: Type): boolean {
    switch (type) {
        case "TF.FieldDefinition":
        case "TF.ItemsItemField":
        case "TF.OptionsItemField":
        case "TF.UserGroupsItemField":
        case "TF.UsersItemField":
            return false
        case "TF.AccountCodeItemField":
        case "TF.ActivityItemField":
        case "TF.ApplicationItemField":
        case "TF.ApplicationVersionItemField":
        case "TF.BillTypeItemField":
        case "TF.DisplayTypeItemField":
        case "TF.ImpactItemField":
        case "TF.ItemItemField":
        case "TF.OptionItemField":
        case "TF.OrganizationItemField":
        case "TF.ProbabilityItemField":
        case "TF.PriorityItemField":
        case "TF.StatusItemField":
        case "TF.UserGroupItemField":
        case "TF.UserItemField":
            return true
    }
}

export function isFieldItemSelect(type: Type): boolean {
    return ["TF.ItemItemField", "TF.ItemsItemField"].includes(type)
}

export function findParent(
    targetId: number,
    groups: GroupOfSelectable[],
): GroupOfSelectable | undefined {
    const parent = groups.find((group) =>
        group.children?.find((child) => child.id === targetId),
    )

    return parent
}
